module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-BoldExte.6be7155.eot";